// extracted by mini-css-extract-plugin
export var primitiveLabel = "_ui-0";